import { render, staticRenderFns } from "./ImportDebtorsModal.vue?vue&type=template&id=b2bbf4de&scoped=true"
import script from "./ImportDebtorsModal.vue?vue&type=script&lang=js"
export * from "./ImportDebtorsModal.vue?vue&type=script&lang=js"
import style0 from "./ImportDebtorsModal.vue?vue&type=style&index=0&id=b2bbf4de&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2bbf4de",
  null
  
)

export default component.exports